import { InjectionToken } from '@angular/core';
import { IDiagnosisService } from './diagnosis-service.interface';

export const DIAGNOSIS_SERVICE = new InjectionToken<IDiagnosisService>(
  'DIAGNOSIS_SERVICE'
);
